export function checkSymptoms() {
    const symptom = document.querySelectorAll(".symptom");
    [...symptom].forEach((symptom) => {
        symptom.addEventListener("click", function () {
            if(symptom.getAttribute("data-answer") === "true") {
                symptom.classList.add("true");
            } else {
                symptom.classList.add("false");
            }
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/check-symptoms.js